const routes = [
    {
        path: "/coop/and/public/scholarships",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "scholarship_index" 
        }
    }
];

export default routes